import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics/constants';

export const Wrapper = styled.div.attrs({
  className: 'container mx-auto max-w-6xl px-6 pt-6 pb-32',
})``;
export const UpdatesContainer = styled.div.attrs({
  className: 'space-y-6 bg-card rounded-lg shadow p-6',
})``;
export const UpdateSection = styled.div.attrs({ className: 'space-y-4' })``;
export const UpdateStatus = styled.p.attrs({ className: 'text-sm text-muted-foreground' })``;
export const ProgressContainer = styled.div.attrs({ className: 'space-y-2' })``;
export const ProgressBar = styled.progress.attrs({
  className: 'w-full h-2',
})``;
export const SectionDivider = styled.hr.attrs({ className: 'border-border' })``;
export const DeviceListHeading = styled.h3.attrs({ className: 'text-sm font-medium' })``;
export const DeviceList = styled.ul.attrs({
  className: 'list-disc pl-5 text-sm text-muted-foreground',
})``;
export const DeviceListItem = styled.li.attrs({ className: MASKED_TEXT_CLASS })``;
